document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll('[data-countdown]');
  counters.forEach((counter) => {
    const hours = Number(counter.dataset.hours || 24);
    const key = 'neonDropCountdown_' + hours;
    let end = Number(localStorage.getItem(key));
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 60 * 60 * 1000;
      localStorage.setItem(key, String(end));
    }
    const update = () => {
      const diff = Math.max(0, end - Date.now());
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      counter.querySelector('[data-days]').textContent = String(d).padStart(2, '0');
      counter.querySelector('[data-hours]').textContent = String(h).padStart(2, '0');
      counter.querySelector('[data-minutes]').textContent = String(m).padStart(2, '0');
      counter.querySelector('[data-seconds]').textContent = String(s).padStart(2, '0');
    };
    update();
    setInterval(update, 1000);
  });
});

document.querySelectorAll('[data-lamp-catalog]').forEach((catalog) => {
  const search = catalog.querySelector('[data-lamp-search]');
  const cards = Array.from(catalog.querySelectorAll('[data-lamp-card]'));
  const buttons = Array.from(catalog.querySelectorAll('[data-lamp-filter]'));
  let activeFilter = 'all';

  const applyFilters = () => {
    const q = (search?.value || '').trim().toLowerCase();
    const normalizedCodeQuery = q.replace('l-', '').replace(/^0+/, '');
    cards.forEach((card) => {
      const rawCode = (card.dataset.code || '').toLowerCase();
      const codeNumber = rawCode.replace('l-', '').replace(/^0+/, '');
      const characterName = (card.dataset.name || '').toLowerCase();
      const stock = Number(card.dataset.stock || '0');
      const isTop = card.querySelector('.lamp-card__badge')?.textContent?.toLowerCase().includes('top');
      const matchesSearch = !q || characterName.includes(q) || rawCode.includes(q) || codeNumber.includes(normalizedCodeQuery) || ('l-' + codeNumber).includes(q);
      const matchesFilter = activeFilter === 'all' || (activeFilter === 'in-stock' && stock > 0) || (activeFilter === 'top' && isTop);
      card.hidden = !(matchesSearch && matchesFilter);
    });
  };

  search?.addEventListener('input', applyFilters);
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.lampFilter || 'all';
      buttons.forEach((b) => b.classList.toggle('is-active', b === button));
      applyFilters();
    });
  });
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const mainImage = gallery.querySelector('[data-product-main] img');
  const thumbnails = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
  if (!mainImage || thumbnails.length === 0) return;

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      mainImage.src = thumbnail.dataset.src || mainImage.src;
      mainImage.alt = thumbnail.dataset.alt || mainImage.alt;
      thumbnails.forEach((item) => item.classList.toggle('is-active', item === thumbnail));
    });
  });
});
